export default function Message() {
    return (
        <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-pink-500 to-rose-500 text-white">
            <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-2xl sm:text-4xl font-bold mb-8">
                    未経験でもプロの技術が身につく<br className="hidden sm:block" />
                    「無料研修」
                </h2>
                <div className="text-lg leading-loose space-y-6 opacity-95 text-justify sm:text-center">
                    <p>
                        「マッサージの経験がないから不安…」という方もご安心ください。<br className="hidden sm:block" />
                        当店認定トレーナーによるオイルマッサージ研修（無料）をご用意しています。
                    </p>
                    <p>
                        接客マナーから施術の流れまで、丁寧にレクチャー。<br className="hidden sm:block" />
                        研修を終えてからのデビューとなるため、自信を持ってお客様に入れます。
                    </p>
                    <p className="font-bold text-xl bg-white/20 inline-block px-6 py-2 rounded-full mt-4">
                        新人優先の集客サポートもあるため、デビュー直後から顧客を獲得しやすい環境です。
                    </p>
                </div>
            </div>
        </section>
    );
}
